<template>
  <header class="service-header p-4">
    <h1 class="fall-down">{{ town.title }}</h1>
    <p class="image-fade-in">
      Boostez votre activité de <strong>fournisseur BTP</strong> grâce à un
      service de <strong>livraison rapide</strong>, fiable et pensé pour le
      <strong
        >transport de matériel sur chantier à {{ town.town }} et ses
        alentours</strong
      >.
    </p>
  </header>
  <TriangleSeparator />
  <main class="container-fluid">
    <div class="container pt-5 my-5">
      <!--Section: Content-->
      <section class="text-center">
        <p
          class="font-weight-normal text-center text-uppercase font-small mb-4 fall-down"
        >
          {{ town.town }}
        </p>
        <!-- Section heading -->
        <h2 class="font-weight-bold mb-4 pb-2 fall-down">
          La livraison BTP simplifiée pour les fournisseurs
        </h2>
        <hr class="w-header" />
        <div class="container mb-5">
          <p class="text-center mx-auto mb-5">
            <span class="brand-name">Livratos</span> est la plateforme dédiée à
            la <strong>livraison</strong> de matériaux pour chaque
            <strong>fournisseur BTP sur {{ town.town }}</strong> et sa région.
            En quelques clics, vous planifiez une
            <strong>livraison sur un chantier à {{ town.town }}</strong> ou sa
            région, un
            <strong>livreur</strong>
            vient charger chez vous et vos matériaux sont
            <strong>livrés</strong> directement aux
            <strong>artisans</strong> sur le <strong>chantier</strong>. Gardez
            vos camions disponibles, gagnez du temps au comptoir et proposez un
            vrai service de <strong>livraison sur {{ town.town }}</strong> à
            tous vos clients BTP.
          </p>
        </div>
        <!-- Section description -->
        <p class="lead mx-auto mt-4 mt-lg-5 pt-2 pt-lg-5 my-5">
          Quelques-uns des avantages qu’offre
          <span class="brand-name">Livratos</span> aux
          <strong>fournisseurs BTP</strong>.
        </p>

        <section class="features">
          <div class="container">
            <div class="container">
              <div class="box">
                <span></span>
                <div class="content">
                  <h2>Facilite les livraisons</h2>
                  <p>
                    Confiez vos courses à un <strong>livreur</strong> dédié et
                    proposez la <strong>livraison sur chantier</strong> à tous
                    vos clients <strong>artisans</strong>, même en pic
                    d’activité, sans bloquer vos propres camions.
                  </p>
                </div>
              </div>
              <div class="box">
                <span></span>
                <div class="content">
                  <h2>Livrez sur le chantier</h2>
                  <p>
                    Une urgence sur un
                    <strong>chantier dans {{ town.town }}</strong> ? Programmez
                    une <strong>livraison</strong> express depuis votre dépôt :
                    vos matériaux sont <strong>livrés</strong> là où les équipes
                    BTP en ont besoin, quand elles en ont besoin.
                  </p>
                </div>
              </div>
              <div class="box">
                <span></span>
                <div class="content">
                  <h2>Livraisons en temps réel</h2>
                  <p>
                    Suivez chaque <strong>livraison</strong> depuis le départ
                    jusqu’au <strong>chantier</strong>. Vos équipes et vos
                    <strong>artisans</strong> savent exactement quand la
                    commande sera <strong>livrée</strong>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!--First row-->
      </section>
    </div>

    <div class="container pt-5 my-5">
      <!--Section: Content-->
      <section class="">
        <!-- Section heading -->

        <!-- Grid row -->
        <div class="container mb-5">
          <h2 class="text-center font-weight-bold mb-4">
            La livraison BTP sur {{ town.town }}<span class="span-ml"> :</span>
          </h2>
          <p class="text-center mx-au">
            Avec <span class="brand-name">Livratos</span>, la
            <strong>livraison sur chantier à {{ town.town }}</strong> devient un
            vrai service premium pour chaque <strong>fournisseur BTP</strong>.
            Depuis votre dépôt, un <strong>livreur</strong> récupère la
            marchandise et elle est <strong>livrée</strong> directement sur le
            <strong>chantier</strong> de vos <strong>artisans</strong> : sacs de
            ciment, palettes, plaques, bois, quincaillerie… Vous gardez la main
            sur la relation client tout en déléguant la logistique de
            <strong>livraison</strong>.
          </p>
        </div>
        <div class="block-row pt-lg-5">
          <!-- Grid column -->
          <div class="block-text col-lg-5 slide-left">
            <!-- Featured image -->

            <!-- Section description -->
            <TitleColor
              title="Comment fonctionne la livraison avec Livratos ?"
              titleColor="#52c234"
            />
            <p class="text-left mx-auto w-responsive">
              La plateforme <span class="brand-name">Livratos</span> simplifie
              la <strong>livraison sur chantier</strong> pour chaque
              <strong>fournisseur BTP</strong> situé à {{ town.town }}. Grâce à
              un réseau structuré de
              <strong>livreurs indépendants sur {{ town.town }}</strong
              >, habitués aux contraintes du <strong>BTP</strong> et aux accès
              parfois complexes des <strong>chantiers</strong>, vous pouvez
              déléguer en toute confiance chaque <strong>livraison</strong>. Il
              vous suffit de créer la commande, d’indiquer le
              <strong>chantier</strong> concerné, la fenêtre horaire souhaitée
              et le matériel à <strong>livrer</strong>. Un
              <strong>livreur</strong> local prend alors la course en charge,
              récupère les matériaux chez le <strong>fournisseur BTP</strong> et
              effectue la <strong>livraison sur chantier</strong> directement
              auprès des <strong>artisans</strong>. <br />
              En centralisant vos demandes de <strong>livraison</strong> avec
              Livratos, vous évitez les allers-retours inutiles entre dépôt et
              <strong>chantier</strong>, réduisez les temps d’attente des
              <strong>artisans</strong> et garantissez une organisation fluide
              même en période de forte activité sur {{ town.town }}. Résultat :
              des matériaux <strong>livrés</strong> au bon endroit, au bon
              moment, et une expérience plus professionnelle pour vos clients
              BTP.
            </p>

            <ArrowBtn
              href="/about"
              whiteCircleBackground="#52c234"
              circleBoxShadow="0 0 2px 2px #52c234"
            />
          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-12 col-lg-5 img-double slide-right">
            <img
              src="@/assets/pictures/vehicule-mockup.webp"
              alt="camion de livraison BTP devant un chantier"
              class="img-fluid"
            />
          </div>
          <!-- Grid column -->
        </div>
        <!-- Grid row -->
      </section>
      <!--Section: Content-->
    </div>

    <!--Section: Content-->
    <section class="container my-5 pb-5">
      <!-- Grid row -->
      <div class="block-row reverse">
        <!-- Grid column -->
        <div class="block-text slide-right col-lg-5">
          <!-- Category -->
          <!-- Post title -->
          <TitleColor
            title="La livraison sur chantier au service des fournisseurs BTP"
            titleColor="#52c234"
            bgColor="#52c234"
          />
          <!-- Excerpt -->
          <p>
            La <strong>livraison sur chantier</strong> est aujourd’hui un
            élément incontournable pour fidéliser vos
            <strong>artisans</strong> et renforcer votre position de
            <strong>fournisseur BTP</strong> à {{ town.town }}. Les équipes du
            BTP ont besoin de recevoir leurs matériaux rapidement, sans détour
            ni perte de temps, et c’est précisément ce que propose
            <span class="brand-name">Livratos</span>. À chaque commande passée,
            un <strong>livreur</strong> local se rend directement chez votre
            dépôt pour récupérer la marchandise, puis assure une
            <strong>livraison sur chantier</strong>
            fiable, sécurisée et réalisée à l’heure prévue.
            <br />
            Grâce à ce fonctionnement fluide, vos matériaux sont
            <strong>livrés</strong>
            exactement là où les équipes travaillent, ce qui évite aux
            <strong>artisans</strong> de quitter leur
            <strong>chantier</strong> ou de mobiliser un véhicule pour aller
            chercher leurs commandes. En tant que
            <strong>fournisseur BTP</strong> à {{ town.town }}, vous offrez
            ainsi un service premium, moderne et parfaitement adapté aux besoins
            réels des entreprises locales du BTP.
          </p>

          <ArrowBtn
            href="/about"
            whiteCircleBackground="#52c234"
            circleBoxShadow="0 0 2px 2px #52c234"
          />
        </div>
        <!-- Grid column -->
        <!-- Grid column -->
        <div class="col-lg-6">
          <!-- Featured image -->
          <div class="view overlay rounded z-depth-2 mb-lg-0 slide-left">
            <img
              src="@/assets/pictures/chargement-mockup.webp"
              alt="livreur BTP chargeant des matériaux dans un camion"
              class="img-fluid"
            />
          </div>
        </div>
        <!-- Grid column -->
      </div>
      <!-- Grid row -->
    </section>
    <!--Section: Content-->
    <ContactUsAction />
    <!--DEVWEB-->
    <div class="container pt-5 my-5">
      <!--Section: Content-->
      <section class="">
        <!-- Section heading -->

        <!-- Grid row -->
        <div class="container mb-5">
          <h2 id="developpement-web" class="text-center font-weight-bold mb-4">
            {{ town.town }}<span class="span-ml"> :</span> Performance
            logistique pour le BTP
          </h2>
          <p class="text-center mx-auto mb-5">
            Avec <span class="brand-name">Livratos</span>, vous améliorez votre
            organisation logistique et la qualité de service auprès de vos
            clients <strong>artisans</strong>. En proposant une
            <strong>livraison</strong> fiable et régulière sur chaque
            <strong>chantier</strong>, vous devenez le partenaire incontournable
            des entreprises du <strong>BTP</strong>. Moins de temps perdu au
            dépôt, plus de commandes, et des matériaux toujours
            <strong>livrés</strong> au bon endroit.
          </p>
        </div>
        <div class="block-row pt-lg-3">
          <!-- Grid column -->
          <div class="block-text col-lg-5 slide-left">
            <!-- Featured image -->

            <!-- Section description -->
            <TitleColor
              title="Comprendre les enjeux de la livraison sur chantier"
              titleColor="#52c234"
            />
            <p class="text-left mx-auto w-responsive">
              Sur un <strong>chantier</strong>, la plupart des interruptions
              proviennent de retards de <strong>livraison</strong> ou d’oublis
              de matériel, ce qui ralentit fortement le travail des
              <strong>artisans</strong> à {{ town.town }}. Pour un
              <strong>fournisseur BTP</strong>, assurer une
              <strong>livraison sur chantier</strong> fiable et régulière
              devient donc indispensable. En confiant vos courses à
              <span class="brand-name">Livratos</span>, vous vous appuyez sur
              des <strong>livreurs</strong> locaux capables d’acheminer les
              matériaux rapidement et au bon endroit, même sur les chantiers
              difficiles d’accès. Vous réduisez ainsi les retards, améliorez
              votre qualité de service et offrez aux
              <strong>artisans</strong> de {{ town.town }} une expérience fluide
              où leurs commandes sont toujours
              <strong>livrées</strong> directement sur le
              <strong>chantier</strong>, sans créer de perte de temps ni
              perturber leur organisation.
            </p>

            <ArrowBtn
              href="/about"
              whiteCircleBackground="#52c234"
              circleBoxShadow="0 0 2px 2px #52c234"
            />
          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-12 col-lg-5 img-double slide-right">
            <img
              src="@/assets/pictures/livraison-programee-2.webp"
              alt="artisan BTP recevant une livraison sur chantier"
              class="img-fluid"
            />
          </div>
          <!-- Grid column -->
        </div>
        <!-- Grid row -->
      </section>
      <!--Section: Content-->
    </div>

    <!--Section: Content-->
    <section class="container my-5 pb-2">
      <!-- Grid row -->
      <div class="block-row reverse">
        <!-- Grid column -->
        <div class="block-text slide-right col-lg-5">
          <!-- Category -->
          <!-- Post title -->
          <TitleColor
            title="Proposer un vrai service de livraison toute l’année"
            titleColor="#52c234"
            bgColor="#52c234"
          />
          <!-- Excerpt -->
          <p>
            Offrir un véritable service de
            <strong>livraison sur chantier</strong> tout au long de l’année est
            devenu un atout essentiel pour accompagner les
            <strong>artisans</strong> de {{ town.town }} dans la gestion
            quotidienne de leurs travaux. Avec
            <span class="brand-name">Livratos</span>, vous permettez à chaque
            <strong>fournisseur BTP</strong> de déléguer simplement ses courses,
            même lors des périodes de forte demande, grâce à des
            <strong>livreurs</strong> disponibles et capables de s’adapter aux
            contraintes de chaque projet. Les matériaux sont pris en charge
            directement à votre dépôt puis déposés au bon endroit sur le
            <strong>chantier</strong>, à l’heure prévue et sans attendre que les
            équipes se déplacent ou interrompent leur planning. Cette continuité
            de <strong>livraison</strong> apporte plus de confort, réduit les
            imprévus et garantit aux professionnels de {{ town.town }} une
            organisation beaucoup plus fluide, sans perte de temps ni trajets
            inutiles entre dépôt et chantier.
          </p>
          <ArrowBtn
            href="/about"
            whiteCircleBackground="#52c234"
            circleBoxShadow="0 0 2px 2px #52c234"
          />
        </div>
        <!-- Grid column -->
        <!-- Grid column -->
        <div class="col-lg-6">
          <!-- Featured image -->
          <div class="view overlay rounded z-depth-2 mb-lg-0 slide-left">
            <img
              src="@/assets/pictures/livraison-express-2.webp"
              alt="fournisseur BTP organisant les livraisons pour ses clients artisans"
              class="img-fluid"
            />
          </div>
        </div>
        <!-- Grid column -->
      </div>
      <!-- Grid row -->
    </section>
    <!--Section: Content-->
    <section class="container mt-lg-5">
      <div class="block-row pt-lg-2 pb-5 mb-5">
        <!-- Grid column -->
        <div class="block-text col-lg-5 slide-left">
          <!-- Featured image -->

          <!-- Section description -->
          <TitleColor
            title="Intégrer la livraison dans votre stratégie commerciale BTP"
            titleColor="#52c234"
            bgColor="#52c234"
          />
          <p class="text-left mx-auto w-responsive">
            Intégrer la <strong>livraison sur chantier</strong> dans votre
            stratégie commerciale permet de renforcer votre position de
            <strong>fournisseur BTP</strong> à {{ town.town }} tout en apportant
            un service réellement différenciant aux <strong>artisans</strong>.
            En proposant des matériaux directement <strong>livrés</strong> sur
            le <strong>chantier</strong>, au créneau demandé et sans
            mobilisation de leurs équipes, vous simplifiez leurs journées et
            devenez un partenaire plus fiable et plus complet. Avec
            <span class="brand-name">Livratos</span>, vos équipes peuvent
            organiser et suivre chaque course en temps réel grâce à un
            <strong>livreur</strong> local qui s’adapte aux contraintes des
            projets, ce qui améliore la précision des commandes, fluidifie les
            échanges et réduit les imprévus. Cette approche renforce la
            confiance, augmente naturellement le panier moyen et valorise votre
            dépôt à {{ town.town }} comme un acteur moderne, flexible et tourné
            vers les besoins concrets du secteur BTP.
          </p>

          <ArrowBtn
            href="/about"
            whiteCircleBackground="#52c234"
            circleBoxShadow="0 0 2px 2px #52c234"
          />
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="col-12 col-lg-5 pt-lg-5 img-double slide-right">
          <img
            src="@/assets/pictures/livraison-express-1.webp"
            alt="tableau de suivi des livraisons BTP"
            class="img-fluid"
          />
        </div>
        <!-- Grid column -->
      </div>
      <!-- Grid row -->
      <!-- Grid row -->
      <ContactUsAction />
      <!-- Grid row -->
    </section>
    <!--/DEVWEB-->
    <!--SEO/SEA-->
    <div class="container my-5">
      <!--Section: Content-->
      <section class="">
        <!-- Section heading -->

        <!-- Grid row -->
        <div class="container mb-lg-5">
          <h2
            id="referencement-google"
            class="text-center font-weight-bold mb-4"
          >
            Des livraisons adaptées à chaque type de chantier
          </h2>
          <p class="text-center mx-auto">
            Avec <span class="brand-name">Livratos</span>, chaque
            <strong>livraison</strong> est pensée pour le terrain : rénovation,
            gros œuvre, second œuvre, petits dépannages ou gros
            <strong>chantier</strong> de <strong>BTP</strong>. Vous choisissez
            le type de matériel à <strong>livrer</strong>, le point de retrait
            et le <strong>chantier</strong> de destination, puis un
            <strong>livreur</strong> adapté prend en charge la course. Vous
            offrez à vos clients <strong>artisans</strong> un service de
            <strong>livraison sur chantier</strong> dimensionné à leurs besoins
            réels.
          </p>
        </div>
        <div class="block-row pt-5">
          <!-- Grid column -->
          <div class="block-text col-lg-5 slide-left">
            <!-- Featured image -->

            <!-- Section description -->
            <TitleColor
              title="Adapter chaque livraison au terrain BTP"
              titleColor="#52c234"
            />
            <p class="text-left mx-auto w-responsive">
              Chaque <strong>chantier</strong> présente ses propres contraintes
              : accès étroits, zones encombrées, horaires stricts ou
              instructions particulières liées à la sécurité. Pour un
              <strong>fournisseur BTP</strong> à {{ town.town }}, réussir une
              <strong>livraison</strong> dans ces conditions nécessite une
              organisation précise et un <strong>livreur</strong> capable de
              s’adapter rapidement. Grâce à
              <span class="brand-name">Livratos</span>, vous pouvez préciser
              chaque détail de la course — type de véhicule requis, emplacement
              exact sur le <strong>chantier</strong>, contact sur place, créneau
              horaire — afin que le <strong>livreur</strong> arrive préparé et
              effectue la <strong>livraison</strong> dans les meilleures
              conditions. Cette préparation en amont limite les imprévus, évite
              les allers-retours inutiles et garantit aux
              <strong>artisans</strong> de {{ town.town }} des matériaux
              toujours <strong>livrés</strong> au bon endroit et au bon moment.
            </p>

            <ArrowBtn
              href="/"
              whiteCircleBackground="#52c234"
              circleBoxShadow="0 0 2px 2px #52c234"
            />
          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-12 col-lg-5 img-double slide-right">
            <img
              src="@/assets/pictures/visu-livratos-2.webp"
              alt="illustration de différents chantiers BTP livrés"
              class="img-fluid spe-img"
            />
          </div>
          <!-- Grid column -->
        </div>
        <!-- Grid row -->
      </section>
      <!--Section: Content-->
    </div>

    <!--Section: Content-->
    <section class="container my-5 pb-5">
      <!-- Grid row -->
      <div class="block-row reverse">
        <!-- Grid column -->
        <div class="block-text slide-right col-lg-5">
          <!-- Category -->
          <!-- Post title -->
          <TitleColor
            title="Suivre et contrôler vos livraisons en temps réel"
            titleColor="#52c234"
            bgColor="#52c234"
          />
          <!-- Excerpt -->
          <p class="text-left mx-auto w-responsive">
            Grâce à l’interface <span class="brand-name">Livratos</span>, vous
            accédez en temps réel au suivi complet de chaque
            <strong>livraison</strong> effectuée à {{ town.town }} : course en
            préparation, <strong>livraison</strong> en cours, commande
            <strong>livrée</strong>, éventuels retards ou remarques laissées par
            le <strong>livreur</strong> ou l’<strong>artisan</strong> présent
            sur le <strong>chantier</strong>. Cette visibilité instantanée vous
            permet d’anticiper les imprévus, d’informer rapidement vos clients
            BTP et de garantir une qualité de service stable tout au long de la
            journée. Avec un contrôle précis des mouvements de matériel et des
            délais, votre <strong>livraison sur chantier</strong> devient un
            processus fiable, transparent et entièrement pilotable, renforçant
            la confiance des professionnels de {{ town.town }} dans votre
            organisation.
          </p>

          <ArrowBtn
            href="/"
            whiteCircleBackground="#52c234"
            circleBoxShadow="0 0 2px 2px #52c234"
          />
        </div>
        <!-- Grid column -->
        <!-- Grid column -->
        <div class="col-lg-6">
          <!-- Featured image -->
          <div class="view overlay rounded z-depth-2 mb-lg-0 slide-left">
            <img
              src="@/assets/pictures/login-mockup.webp"
              alt="écran de suivi des livraisons BTP multi-chantiers"
              class="many-picture-of-different-job"
            />
          </div>
        </div>
        <!-- Grid column -->
      </div>
      <!-- Grid row -->
    </section>
    <!--Section: Content-->
    <ContactUsAction />
    <!--/SEASEO-->
    <!--MARKETING-->
    <div class="container mt-5">
      <!--Section: Content-->
      <section class="">
        <!-- Section heading -->

        <!-- Grid row -->
        <div class="container mb-lg-5 mt-5">
          <h2 id="marketing-digital" class="text-center font-weight-bold mb-4">
            {{ town.content }}<span class="span-ml"> :</span>
          </h2>
          <p class="text-center mx-auto mb-lg-5">
            <span class="brand-name">Livratos</span> est née de la rencontre
            entre des professionnels du <strong>BTP</strong> et des experts du
            digital. Ensemble, ils ont conçu une solution simple pour connecter
            <strong>fournisseurs BTP</strong>, <strong>livreurs</strong> et
            <strong>artisans</strong> autour d’une même promesse : des matériaux
            <strong>livrés</strong> au bon moment, sur le bon
            <strong>chantier</strong>. La plateforme modernise la
            <strong>livraison sur chantier</strong> et vous aide à faire de ce
            service un vrai levier de croissance.
          </p>
        </div>
        <div class="block-row pt-5">
          <!-- Grid column -->
          <div class="block-text col-lg-5 slide-left">
            <!-- Featured image -->

            <!-- Section description -->
            <TitleColor title="L'histoire de Livratos" titleColor="#52c234" />
            <p class="text-left mx-auto w-responsive">
              Pensée comme un « Uber » de la <strong>livraison</strong> pour le
              <strong>BTP</strong>, <span class="brand-name">Livratos</span> a
              été créée pour répondre à un constat simple : les
              <strong>artisans</strong> perdent des heures à aller chercher
              leurs matériaux et les <strong>fournisseurs BTP</strong> n’ont pas
              toujours les moyens d’assurer eux-mêmes la
              <strong>livraison sur chantier</strong>. En centralisant les
              demandes de <strong>livraison</strong> et en les confiant à des
              <strong>livreurs</strong> disponibles, la plateforme permet à
              chacun de se concentrer sur son métier : vendre pour le
              <strong>fournisseur BTP</strong>, produire pour
              l’<strong>artisan</strong>, <strong>livrer</strong> efficacement
              pour le <strong>livreur</strong>. Résultat : des matériaux mieux
              <strong>livrés</strong>, des <strong>chantiers</strong> plus
              fluides, et une relation client renforcée.
            </p>
            <ArrowBtn
              href="/"
              whiteCircleBackground="#52c234"
              circleBoxShadow="0 0 2px 2px #52c234"
            />
          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-12 col-lg-5 img-double slide-right">
            <img
              src="@/assets/brand/logo-y.webp"
              alt="logo de la plateforme de livraison BTP Livratos"
              class="img-fluid"
            />
          </div>
          <!-- Grid column -->
        </div>
        <!-- Grid row -->
      </section>
      <!--Section: Content-->
    </div>

    <!--Section: Content-->

    <!--Section: Content-->
    <!--/Marketing-->
    <div class="container service-contact image-fade-in">
      <CallActionService />
    </div>
  </main>
</template>

<script>
import { useMeta } from "vue-meta";
import { toRef, watchEffect } from "vue";
import TriangleSeparator from "@/components/partials/TriangleSeparator.vue";
import ArrowBtn from "@/components/partials/ArrowBtn.vue";
import TitleColor from "@/components/partials/TitleColor.vue";
import ContactUsAction from "@/components/partials/ContactUsAction.vue";
import CallActionService from "@/components/partials/CallActionService.vue";
import { mapGetters } from "vuex";
import { formatDate } from "@/assets/globalJs/global.js";

export default {
  components: {
    TriangleSeparator,
    ArrowBtn,
    TitleColor,
    ContactUsAction,
    CallActionService,
  },
  name: "TownRead",
  props: {
    town: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const townProp = toRef(props, "town");

    watchEffect(() => {
      if (townProp.value) {
        const townName = townProp.value.town;

        const sentenceBegin =
          "Organisez vos livraisons de matériaux BTP directement sur chantier à " +
          townName +
          ". ";
        const sentenceEnd =
          " Avec Livratos, les fournisseurs BTP de " +
          townName +
          " planifient leurs livraisons sur chantier, délèguent les courses à des livreurs indépendants locaux et offrent à leurs artisans un service de livraison rapide, fiable et adapté aux réalités du terrain.";

        const metaDescription =
          sentenceBegin + townProp.value.content + sentenceEnd;

        // On nettoie le slug en supprimant l'ID de fin si présent
        const rawSlug = townProp.value.slug; // ex: "la-livraison-sur-chantier-pour-le-btp-sur-paris-692e0381adf7c"
        let canonicalSlug = rawSlug;

        // Si le dernier segment est un ID type hash / long (ex: 10+ caractères alphanumériques), on le retire
        const parts = rawSlug.split("-");
        const lastPart = parts[parts.length - 1];

        if (lastPart && lastPart.length >= 8) {
          // on considère que c'est l'ID
          parts.pop();
          canonicalSlug = parts.join("-");
        }

        useMeta({
          title: "Livraison de matériaux BTP sur chantier à " + townName,
          description: [
            {
              content: metaDescription,
            },
          ],
          link: [
            {
              rel: "canonical",
              href:
                "https://www.livratos.fr/livraisons-chantier/" + canonicalSlug,
            },
          ],
        });
      }
    });

    return {
      townData: townProp,
    };
  },
  computed: {
    formattedDate() {
      return formatDate(this.town.updatedAt);
    },
    ...mapGetters({
      Towns: "StateTowns",
      User: "StateUser",
      TownDataFromStore: "StateTown",
    }),
  },
  methods: {
    scrollTo(sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        window.scrollTo({
          top: section.offsetTop,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// =========================
// Palette minimale Livratos
// =========================
$primary: $color-primary;
$black: #000;
$white: #fff;

// =========================
// Typo & utilitaires
// =========================
.service-header {
  margin-top: 72px;
}

p,
h2,
h3,
h4 {
  color: $color-darker;
}

.brand-name {
  color: $primary;
}

.span-ml {
  margin-left: 4px;
}

// =========================
// Header service
// =========================
.service-header {
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  background: #52c234; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #061700,
    #52c234
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #061700,
    #52c234
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  h1 {
    color: $white;
    font-size: 2em;
    text-align: center;
  }

  p {
    color: $color-lighter;
    font-size: 1.3em;
    text-align: center;

    .fake-space {
      margin-left: 8px;
    }
  }
}

// =========================
// Cartes génériques service
// =========================
.card-service:hover {
  @include grow;
}

.service-card {
  @include thumbnail;
  height: 100%;
  padding: 15px;

  .card-body {
    padding: 0;

    h4 {
      font-size: 1.3em;
      margin: 15px 5px 0;
      color: $color-text-grey;
    }
  }
}

// =========================
// Layout blocs texte / image
// =========================
.block-row {
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: 992px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }

  video,
  img {
    width: 500px;
    max-width: 90vw;
    margin-top: 30px;
    margin-bottom: 10px;

    @media screen and (min-width: 992px) {
      width: 500px;
      margin-top: 30px;
      margin-bottom: 0;
    }
  }
  .spe-img {
    max-width: 370px;
  }

  .img-double {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .hr {
    width: 50px;
    height: 3px;
    background-color: $background;
  }
}

.reverse {
  flex-direction: column-reverse;

  @media screen and (min-width: 992px) {
    flex-direction: row-reverse !important;
  }
}

// =========================
// Section call-to-action
// =========================
.service-contact {
  margin-top: 100px;
  margin-bottom: 200px;

  @media screen and (min-width: 992px) {
    margin-top: 200px;
  }

  &__text {
    display: flex;
    flex-direction: column;
    justify-content: center;

    h3 {
      color: $color-lighter;
    }

    a {
      background: $bold-light-primary;
      width: fit-content;
      margin: auto;

      &:hover {
        background: $primary;
        border-color: $color-text;
      }
    }
  }
}

// =========================
// Traits colorés (blocs)
// Tout passe sur la même logique vert Livratos
// =========================
.cyan,
.purple,
.orange,
.yellow {
  border-top: 1.5px solid $primary;
}

// =========================
// Effet "encre" (si utilisé)
// =========================
.ink {
  width: 200px;
  height: 200px;
  background-color: $black;
  border-radius: 50%;
  position: relative;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 100px;
    height: 150px;
    background-color: $black;
    border-radius: 50%;
    transform: rotate(45deg);
  }

  &::before {
    top: -30px;
    left: 50px;
  }

  &::after {
    bottom: -60px;
    right: 50px;
  }
}

// =========================
// Features (3 boxes Livratos)
// =========================
.features {
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 40px 0;
  }

  .container-title {
    font-size: 35px;
    font-weight: bold;
    margin-bottom: 40px;
    color: $color-lighter;
    text-align: center;

    @media (min-width: 992px) {
      font-size: 51px;
      margin-bottom: 80px;
    }
  }

  .container .box {
    position: relative;
    width: 320px;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 40px 30px;
    transition: 0.5s;
  }

  // Fond "skew" – neutre (blanc) animé
  .container .box::before {
    content: "";
    position: absolute;
    top: 0;
    left: 50px;
    width: 50%;
    height: 100%;
    background: $white;
    border-radius: 8px;
    transform: skewX(15deg);
    transition: 0.5s;
  }

  .container .box::after {
    content: "";
    position: absolute;
    top: 0;
    left: 50px;
    width: 50%;
    height: 100%;
    background: $white;
    border-radius: 8px;
    transform: skewX(15deg);
    transition: 0.5s;
    filter: blur(30px);
  }

  .container .box:hover::before,
  .container .box:hover::after {
    transform: skewX(0deg);
    left: 20px;
    width: calc(100% - 90px);
  }

  // Variation subtile par carte : juste l'opacité du vert/ noir
  .container .box:nth-child(1)::before,
  .container .box:nth-child(1)::after {
    background: linear-gradient(315deg, #52c234, $primary);
  }

  .container .box:nth-child(2)::before,
  .container .box:nth-child(2)::after {
    background: linear-gradient(315deg, $primary, #52c234);
  }

  .container .box:nth-child(3)::before,
  .container .box:nth-child(3)::after {
    background: linear-gradient(315deg, #52c234, $primary);
  }

  // Effets vitre / glow
  .container .box span {
    display: block;
    position: absolute;
    inset: 0;
    z-index: 5;
    pointer-events: none;
  }

  .container .box span::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    border-radius: 8px;
    background: rgba($white, 0.1);
    backdrop-filter: blur(10px);
    opacity: 0;
    transition: 0.1s;
    animation: animate 2s ease-in-out infinite;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  }

  .container .box:hover span::before {
    top: -50px;
    left: 50px;
    width: 100px;
    height: 100px;
    opacity: 1;
  }

  .container .box span::after {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    background: rgba($white, 0.1);
    backdrop-filter: blur(10px);
    opacity: 0;
    transition: 0.5s;
    animation: animate 2s ease-in-out infinite;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
    animation-delay: -1s;
  }

  .container .box:hover span::after {
    bottom: -50px;
    right: 50px;
    width: 100px;
    height: 100px;
    opacity: 1;
  }

  @keyframes animate {
    0%,
    100% {
      transform: translateY(10px);
    }

    50% {
      transform: translate(-10px);
    }
  }

  // Contenu des cartes
  .container .box .content {
    position: relative;
    left: 0;
    padding: 20px 40px;
    background: rgba($black, 0.9);
    backdrop-filter: blur(10px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    z-index: 1;
    color: $white;
    transition: 0.5s;
    height: 90%;
  }

  .container .box:hover .content {
    left: -25px;
    padding: 60px 40px;
  }

  .container .box .content h2 {
    font-size: 2em;
    color: $color-primary;
    margin-bottom: 10px;
  }

  .container .box .content p {
    font-size: 1.1em;
    margin-bottom: 10px;
    line-height: 1.4em;
    color: $white;
  }

  .container .box .content a {
    display: inline-block;
    font-size: 1.1em;
    color: $black;
    background: $white;
    padding: 10px;
    border-radius: 4px;
    text-decoration: none;
    font-weight: 700;
    margin-top: 5px;
    border: 1px solid transparent;
  }

  .container .box .content a:hover {
    background: $primary;
    color: $white;
    border: 1px solid rgba(0, 0, 0, 0.2);
    box-shadow: 0 1px 15px rgba(1, 1, 1, 0.2);
  }
}
</style>
